import { useEffect, useState } from "react"

import type { InitialRenderContext } from "./useInitialRender.types"

export const useInitialRender = <C extends InitialRenderContext>(
  context: C
) => {
  const [initialRender, setInitialRender] = useState(true)

  useEffect(() => {
    setInitialRender(false)
  }, [])

  if (!initialRender) return context

  const { response, isLoading, ...rest } = context

  return { response: undefined, isLoading: true, ...rest }
}
